<h2  [id]="article?.elemId">
  <span *ngIf="article?.level > 0"  [ngClass]="{'translated':article.translated===false}"class="number">{{ article?.number }}</span> <span  [ngClass]="{'translated':article.translated===false}"class="kicker">{{ article?.kicker }}</span> <span [ngClass]="{'translated':article.translated===false}"class="title">{{ article?.title }}</span></h2>
<div #articleContent [ngClass]="{'translated':article.translated===false}"[innerHTML]="article?.text | safeHtml"></div>

<app-interpretation [interpretation]="interpretation" *ngFor="let interpretation of article?.interpretations"></app-interpretation>

<ng-container *ngIf="article?.parent">
  <app-article [article]="item" *ngFor="let item of article.children"></app-article>
<ng-container>
